<template>
  <span class="whitespace-pre-line">
    <template v-if="prices.length === 1">
      {{
        i18n(translations.onePeriodPrice, {
          price: i18n.price(prices[0].price),
        })
      }}
    </template>

    <template v-if="prices.length === 2 && prices[0].monthsDuration">
      <template v-if="shouldUseYears">
        {{
          i18n(translations.twoPeriodsPricesInYears, {
            firstPeriodPrice: i18n.price(prices[0].price),
            secondPeriodPrice: i18n.price(prices[1].price),
            years: prices[0].monthsDuration / 12,
          })
        }}
      </template>

      <template v-else>
        {{
          i18n(translations.twoPeriodsPricesInMonths, {
            firstPeriodPrice: i18n.price(prices[0].price),
            secondPeriodPrice: i18n.price(prices[1].price),
            months: prices[0].monthsDuration,
          })
        }}
      </template>
    </template>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { PriceOption } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './PriceOption.translations'

const i18n = useI18n()

const props = defineProps<{ prices: PriceOption['prices'] }>()

const shouldUseYears = computed(() => {
  if (!props.prices[0].monthsDuration) return false

  return props.prices[0].monthsDuration % 12 === 0
})
</script>
